import _ from 'lodash';
import moment from 'moment';
import accounting from 'accounting-js';
import indefiniteArticle from 'indefinite-article';

export function queryParams () {
    return _(window.location.search.slice(1).split('&'))
        .pull('')
        .map(item => item.split('='))
        .fromPairs()
        .value();
}

export function queryParam (variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (false);
}

export function arrayWrap (value) {
    if (value === null || value === undefined)
        return [];

    return (typeof value == Array) ? value : Array.of(value);
}

export function formatNumber (number) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ','); //thousands separator
}

export function formatCurrency (number) {
    return accounting.formatMoney(number, {symbol: "$"}).substring(1);
}

export function formatNullableCurrency (number) {
    return (number != null) ? '$' + formatCurrency(number) : '-';
}

export function trimDecimals (value) {
    const index = value.indexOf('.');

    return index ? value.substring(0, index) : value
}

export function formatDateRange (startDate, endDate) {
    let dateRange = startDate ? formatDate(startDate) : '';
    dateRange += endDate ? ' - ' + formatDate(endDate) : '';
    return dateRange === '' ? 'None' : dateRange;
}

export function formatDate (date) {
    return moment(date).format('MM/DD/YYYY');
}

export function formatDateTime (date) {
    return moment(date).format('MM/DD/YYYY hh:mmA');
}

export function isBeforeStartOfDay () {
    return serverDate().isBefore(moment(window.Portal.startOfDay));
}

export function serverDate () {
    return moment(window.Portal.serverTime);
}

export function simpleEmailValidator (email) {
    const emailRegex = /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailRegex.test(email);
}

export function todaysStartTime () {
    const startTime = moment(window.Portal.startOfDay)

    return isBeforeStartOfDay()
        ? startTime.subtract(1, 'days')
        : startTime
}

export function dayOfWeek () {
    return moment(window.Portal.serverTime).format('E');
}

export function capitalize (value) {
    if (!value) return '';
    value = value.toString().toLowerCase();
    return value.charAt(0).toUpperCase() + value.slice(1);
}

export function indefinite (word) {
    return `${indefiniteArticle(word)} ${word}`;
}

/**
 * returns url safe version of given word.
 * credit to https://gist.github.com/mathewbyrne/1280286
 * @param {string} word
 * @returns {string}
 */
export function slugify(word) {
    return `${word}`.toLowerCase()
        .replace(/\s+/g, '-')      // Replace spaces with -
        .replace(/[^\w\-]+/g, '')  // Remove all non-word chars
        .replace(/\-\-+/g, '-')    // Replace multiple - with single -
        .replace(/^-+/, '')        // Trim - from start of text
        .replace(/-+$/, '');       // Trim - from end of text
}
